module.exports = __webpack_public_path__ + "img/2024-10-16f_5.f0629f46.jpg";